<template>
  <v-container fluid>
    <base-material-card
      color="primary"
      icon="mdi-magnify-scan"
      inline
      class="px-5 py-4"
    >
      <template v-slot:after-heading>
        <div class="display-2 font-weight-light">
          {{title}}
        </div>
      </template>
      <v-row class="mt-5">
        <v-col cols="12">
          <validation-provider v-slot="{ errors }" rules="required">
            <v-text-field
              id="titulo-analise-bp"
              v-model="nome"
              label="Nome"
              outlined
              :error-messages="errors"
            />
          </validation-provider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12"
          id="date-picker-data-base"
        >
          <date-picker
            v-model="dataBase"
            label="Data Base"
            type="month"
            rules="required|min:7"
          />
        </v-col>
      </v-row>
      <v-row
        id="date-picker-data-nota-fiscal"
      >
        <v-col cols="5">
          <date-picker
            v-model="dataNotaFiscalInicial"
            label="Data Nota Fiscal Inicial"
            type="date"
            :rules="{required_if: dataNotaFiscalFinal != null, min:10}"
          />
        </v-col>
        <v-col cols="2" class="text-center" style="align-self: center">
          <span style="color: rgba(0, 0, 0, 0.54); font-size:15px">até</span> 
        </v-col>
        <v-col cols="5">
          <date-picker
            v-model="dataNotaFiscalFinal"
            label="Data Nota Fiscal Final"
            type="date"
             :rules="{required_if: dataNotaFiscalInicial != null, min:10}"
          />
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
export default {
  components: {
    DatePicker: () => import("@/components/general/DatePicker.vue")
  },

  props: {
    title: {
      type: String,
      required:true
    },
    item: {
      type: Object,
      default: ()=> {}
    }
  },

  mounted() {
    if (this.$route.params.id) this.fillFields();
  },

  data: () => ({
    nome: null,
    dataBase: null,
    dataNotaFiscalInicial: null,
    dataNotaFiscalFinal: null
  }),

  methods: {
    fillFields() {
      this.nome = this.item.nome;
      this.dataBase = this.getOnlyDateIgnoringTimestamp(this.item.data_base);
      this.dataNotaFiscalInicial = this.getOnlyDateIgnoringTimestamp(this.item.data_nota_fiscal_inicial);
      this.dataNotaFiscalFinal = this.getOnlyDateIgnoringTimestamp(this.item.data_nota_fiscal_final);
    },

    exportData() {
      return {
        id : !this.$route.params.id ? null : this.$route.params.id,
        nome: this.nome,
        data_base: this.dataBase,
        data_nota_fiscal_inicial: this.dataNotaFiscalInicial,
        data_nota_fiscal_final: this.dataNotaFiscalFinal
      };
    },

    getOnlyDateIgnoringTimestamp(date) {
      if (date && date.length > 10) { date = date.substr(0, 10) }
      return date;
    }
  },

  watch: {
    item() {
      this.fillFields();
    }
  }
}
</script>